import { defaultDeviceTypesSelection } from 'common/utils/constants';
import React from 'react';
import DeviceTypeChip from '../DeviceTypeChip/DeviceTypeChip';

import './KpiDetailsCard.css';

const getSupportedProductTypes = (supportedProducts) => {
  if (!supportedProducts) return [];
  const typeEnum = defaultDeviceTypesSelection.map((type) => type.name);
  const displayEnum = defaultDeviceTypesSelection.map((type) => type.title);
  if (supportedProducts.includes('all')) {
    return displayEnum;
  }
  return supportedProducts.reduce((ret, sp) => {
    const index = typeEnum.indexOf(sp);
    if (index !== -1) {
      ret.push(displayEnum[index])
    }
    return ret;
  }, []);
};

const KpiDetailsCard = ({ metadata: { uiFriendlyName, description, unit, supportedProducts } }) => {
  return (
    <div className="KpiDetailsCardContainer">
      <div className="KpiDetailsCard_Title">{uiFriendlyName}</div>
      <div className="KpiDetailsCard_Description">{description}</div>
      <div className="KpiDetailsCard_BottomContainer">
        <div className="KpiDetailsCard_UnitContainer">
          <div className="KpiDetailsCard_UnitTitle">Unit:</div>
          <div className="KpiDetailsCard_UnitValue">{unit}</div>
        </div>
        <div className="KpiDetailsCard_ProductsContainer">
          <div className="KpiDetailsCard_ProductsTitle">Supported Products:</div>
          <div className="KpiDetailsCard_ProductsContent">
            {getSupportedProductTypes(supportedProducts).map((productType) => (
              <DeviceTypeChip productType={productType} size={'small'} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default KpiDetailsCard;
